module.exports = __webpack_public_path__ + "static/media/Space-City-Background-Image-for-Website-2018.ceb23d49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Space-City-Background-Image-for-Website-2018.png
// module id = 1118
// module chunks = 0